import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { NotificationsService } from '@core/data/notifications/notifications.service';
import { interval, Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { NotificationMenuComponent } from '../notification-menu/notification-menu.component';
import { Store } from '@ngrx/store';
import { selectAuditPollInterval } from '@core/store/selectors/api-config.selectors';
import { CommonModule } from '@angular/common';
import { CypressDirectiveModule } from '@shared/directives/cypress/cypress-directive.module';
import { ButtonModule } from '@shared/components/atoms/button/button.module';
import { TranslocoModule } from '@jsverse/transloco';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'xt-portal-notification-indicator',
  templateUrl: './notification-indicator.component.html',
  styleUrls: ['./notification-indicator.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CypressDirectiveModule,
    TranslocoModule,
  ],
})
export class NotificationIndicatorComponent implements OnInit, OnDestroy {
  @Output() toggleMenuEvent = new EventEmitter();
  private destroy$ = new Subject<void>();
  hasUnreadNotifications$: Observable<boolean>;

  constructor(
    private dialog: MatDialog,
    private overlay: Overlay,
    private notificationsService: NotificationsService,
    private store: Store,
  ) {}

  ngOnInit() {
    this.hasUnreadNotifications$ =
      this.notificationsService.hasUnreadNotifications$;

    this.store.pipe(selectAuditPollInterval).subscribe((auditPollInterval) => {
      const auditPollIntervall = auditPollInterval * 1000;
      this.fetchNotifications(auditPollIntervall);
    });
  }

  fetchNotifications(num) {
    // Fetch immediately when called
    this.fetchNotificationsData();

    interval(num)
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.fetchNotificationsData()),
      )
      .subscribe();
  }

  private fetchNotificationsData() {
    this.notificationsService.fetchDataBasedOnContext();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * opens the dialog for notifications
   * Uses block scroll strategy to prevent background scrolling on iOS
   */
  openDialog(): void {
    this.dialog.open(NotificationMenuComponent, {
      panelClass: 'dialog-container-notification',
      backdropClass: 'backdrop-no-shadow',
      maxHeight: '500px',
      maxWidth: '430px',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
    });
    this.toggleMenuEvent.emit();
  }
}
